import { ICreateBiometriaFacialFuncionarioUseCase } from "../../../presentation/useCases/create/create_biometria_facial_funcionario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";


export class CreateBiometriaFacialFuncionarioUseCase implements ICreateBiometriaFacialFuncionarioUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createBiometriaFacialFuncionario(
    idFuncionario: number | null,
    data: Date,
    hora: string,
    biometria: string | null,
    idTermoEpi: number
  ): Promise<void> {
    await this.repository.createBiometriaFacialFuncionario(
      idFuncionario,
      data,
      hora,
      biometria,
      idTermoEpi
    );
  }
}
